/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function() {
  'use strict';

  angular.module('app.theme')
    .run(themeRun);

  /** @ngInject */
  function themeRun($timeout, $rootScope, $http, $q, fieldDomains, agoSecurity, $window, sessionService, $location) { // jshint ignore:line
    $rootScope.session = sessionService;
    $window.app = {
      authState: function(state, user) {
        switch (state) {
          case 'success':
            sessionService.authSuccess(user);
            break;
          case 'failure':
            sessionService.authFailed();
            break;
        }
      }
    };

    if ($window.user !== null) {
      sessionService.authSuccess($window.user, $location.path());
    }
  }
})();
